const environments = {
  development: {
    domain: 'localhost',
    apiURL: 'http://localhost:3000/development',
    apiURLAdmin: 'http://localhost:3000/development',
    pusherKey: '29102e4bcb433855da7d'
  },
  staging: {
    domain: 'amazonaws.com',
    apiURL: 'https://rnvchqqd06.execute-api.eu-north-1.amazonaws.com/staging',
    apiURLAdmin: 'https://rnvchqqd06.execute-api.eu-north-1.amazonaws.com/staging',
    pusherKey: '9919fe20b8b4a519d673'
  },
  production: {
    domain: 'ateljenspizza.se',
    apiURL: 'https://v71sfjbh1e.execute-api.eu-north-1.amazonaws.com/production',
    apiURLAdmin: 'https://v71sfjbh1e.execute-api.eu-north-1.amazonaws.com/production',
    pusherKey: '43bc0fae26e2cf797b4d'
  }
};

const domain = window.location.hostname.split('.').slice(-2).join('.');

const env = environments[Object.keys(environments).find(e => environments[e].domain === domain)];
if (!env) {
  throw new Error('Couldn\'t decide current environment on domain ' + domain);
}

const appConfig = {
  ...env
};

export default appConfig;
